import React from 'react';
import { problems } from '../data/content';
export function ProblemSection() {
  return <section className="w-full bg-paper py-11 sm:py-14 lg:py-16" aria-labelledby="problema" data-id="element-144" data-mp="2lstl5l3i8ih6">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-145" data-mp="30gxvo1selnov">
        <h2 id="problema" className="max-w-3xl font-display text-2xl font-extrabold leading-[1.12] tracking-tight text-navy sm:text-4xl" data-id="element-146" data-mp="30iis5wya3gpd">
          No es que no te dejen avanzar.{' '}
          <span className="text-celeste-deep" data-id="element-147" data-mp="39jqo48dbo5ga">Es que hay un dato informado a tu nombre.</span>
        </h2>
        <p className="mt-3 max-w-2xl text-[15px] leading-relaxed text-navy-soft sm:text-lg" data-id="element-148" data-mp="3jg20eycwwvaq">
          Estos son los casos donde SOS VERAZ te muestra qué figura y qué corresponde hacer:
        </p>

        <ul className="mt-6 grid grid-cols-1 gap-px overflow-hidden rounded-2xl bg-navy/10 sm:mt-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-149" data-mp="1p212qgt3mec8">
          {problems.map(p => <li key={p.title} className="flex flex-col bg-white p-4 sm:p-5" data-id="element-150" data-mp="1k4iuytqti55t">
              <h3 className="font-display text-[17px] font-bold leading-snug text-navy" data-id="element-151" data-mp="je6g10cwmm9g">
                {p.title}
              </h3>
              <p className="mt-1.5 text-[14px] leading-relaxed text-navy-soft" data-id="element-152" data-mp="oa3u100p3gj2">{p.text}</p>
            </li>)}
        </ul>

        <p className="mt-6 max-w-3xl border-l-4 border-oro pl-4 font-display text-lg font-bold leading-snug text-navy sm:text-xl" data-id="element-153" data-mp="x49v97dd9fpe">
          Antes de reclamar hay que saber qué está informado, quién lo informó y desde cuándo.
        </p>
      </div>
    </section>;
}